import { I18nManager } from "../../i18n/i18n-manager";
import { LocaleType } from "../../constants/constants";
import { translationEnGB } from "./en-GB";
import { translationEsES } from "./es-ES";
import { translationFrFR } from "./fr-FR";
import { translationItIT } from "./it-IT";
import { translationPlPL } from "./pl-PL";
import { translationDeDE } from "./de-DE";

class I18nManagerFrontOffice extends I18nManager {
    protected load(locale: LocaleType) {
        switch (locale) {
            case "en-GB":
                return translationEnGB;
            case "fr-FR":
                return translationFrFR;
            case "es-ES":
                return translationEsES;
            case "it-IT":
                return translationItIT;
            case "de-DE":
                return translationDeDE;
            case "pl-PL":
                return translationPlPL;
            default:
                throw new Error(`This locale is not supported`);
        }
    }
}

export const i18nManagerFrontOffice = new I18nManagerFrontOffice();
